<template>
  <div class="my-10">
    <PopupWrapper :platform="POPUP_TYPE.WEB_MALL" />
    <CarouselBanner v-if="mallBanners.length > 0" :content="mallBanners"></CarouselBanner>
    <PosterBannerSmall v-if="mallSmallPosters.length > 0" :content="mallSmallPosters">
    </PosterBannerSmall>
    <div class="grid grid-cols-2 gap-2 max-md:grid-cols-1">
      <SquarePosterBanner
        class="mt-2"
        v-if="mallPoster1.length > 0"
        :content="mallPoster1"
      ></SquarePosterBanner>
      <SquarePosterBanner
        class="mt-2"
        v-if="mallPoster2.length > 0"
        :content="mallPoster2"
      ></SquarePosterBanner>
    </div>

    <div v-if="stores.length > 0" class="mt-5 mb-20">
      <h2 class="text-black text-4xl font-bold">{{ $t('nav.stores') }}</h2>

      <div
        class="mt-5 grid grid-cols-4 gap-8 max-lg:grid-cols-3 max-lg:gap-5 max-md:grid-cols-2 max-md:gap-4"
      >
        <router-link
          v-for="item in stores"
          :key="item.id"
          :to="{ name: 'storeDetail', params: { id: item.id } }"
        >
          <StoreCard :detail="item"> </StoreCard>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import StoreCard from '@cmp/mall/StoreCard.vue';
import CarouselBanner from '@cmp/CarouselBanner.vue';
import PosterBannerSmall from '@cmp/PosterBannerSmall.vue';
import SquarePosterBanner from '@cmp/SquarePosterBanner.vue';
import PopupWrapper from '@/components/PopupWrapper.vue';
import { POPUP_TYPE } from '@/constants';
export default {
  name: 'mallHome',
  components: {
    CarouselBanner,
    PosterBannerSmall,
    SquarePosterBanner,
    StoreCard,
    PopupWrapper,
  },
  data() {
    return {
      POPUP_TYPE,
      loading: false,
      mallBanners: [],
      mallSmallPosters: [],
      mallPoster1: [],
      mallPoster2: [],
      stores: [],
    };
  },
  methods: {
    async getStores() {
      try {
        const response = await api.get('mall/stores/', {
          params: { subscription: 1, location: this.getLocation.id },
        });
        this.stores = response.data.results;
      } catch (e) {
        console.log(e);
      }
    },
    async getMallBanner() {
      try {
        const response = await api.get('commercials/advertisements/', {
          params: { type: 206, location: this.getLocation.id },
        });
        this.mallBanners = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getMallPoster() {
      try {
        const response = await api.get('commercials/advertisements/', {
          params: { type: 207, location: this.getLocation.id },
        });
        let data = response.data;
        this.mallPoster1 = data.filter(el => el.group_number === 1);
        this.mallPoster2 = data.filter(el => el.group_number === 2);
      } catch (e) {
        console.log(e);
      }
    },
    async getMallSmallPoster() {
      try {
        const response = await api.get('commercials/advertisements/', {
          params: { type: 208, location: this.getLocation.id },
        });
        this.mallSmallPosters = response.data;
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    getLocation() {
      return JSON.parse(localStorage.getItem('selectedLocation')) || 1;
    },
  },
  async created() {
    await this.getStores();
    await this.getMallPoster();
    await this.getMallBanner();
    await this.getMallSmallPoster();
  },
};
</script>
./mallHome.vue
